import { render, staticRenderFns } from "./addressSelect.vue?vue&type=template&id=34094622"
import script from "./addressSelect.vue?vue&type=script&lang=js"
export * from "./addressSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports